import { Type } from '@angular/core';

import { SportDefinition, SportProfileField } from '../sport.types';
import { BasketballScoringAdapter } from './basketball-scoring.adapter';
import { BASKETBALL_POSITIONS } from './basketball.models';

const profileFields: SportProfileField[] = [
  {
    key: 'position',
    label: 'Position',
    section: 'profile',
    type: 'select',
    filterable: true,
    options: BASKETBALL_POSITIONS.map(p => ({ value: p.value, label: p.label }))
  },
  { key: 'jerseyNumber', label: 'Jersey #', section: 'profile', type: 'number', min: 0, max: 99 },
  { key: 'height', label: 'Height', section: 'profile', type: 'text', hint: 'e.g. 6\'2"' },
  { key: 'weight', label: 'Weight (lbs)', section: 'profile', type: 'number', min: 0, max: 400 },
  {
    key: 'dominantHand',
    label: 'Dominant hand',
    section: 'profile',
    type: 'select',
    options: [
      { value: 'right', label: 'Right' },
      { value: 'left', label: 'Left' }
    ]
  },

  { key: 'equipment.shoeBrand', label: 'Shoe brand', section: 'equipment', type: 'text' },
  { key: 'equipment.shoeModel', label: 'Shoe model', section: 'equipment', type: 'text' }
];

export function createBasketballSportDefinition(input: {
  scoring: BasketballScoringAdapter;
  setupComponent: Type<unknown>;
  liveComponent: Type<unknown>;
  spectatorComponent?: Type<unknown>;
}): SportDefinition {
  return {
    key: 'basketball',
    label: 'Basketball',
    icon: 'sports_basketball',
    colorToken: '--brijjsports-orange',
    athletesNoun: 'Players',
    terminology: {
      eventNoun: 'Tournament',
      eventNounPlural: 'Tournaments',
      sessionNoun: 'Game',
      opponentNoun: 'Opponent',
      scoreUnitNoun: 'Point',
      resultPlacementHelp: '1st, Runner-up, 3-1'
    },
    rulesSummary: 'Quarter-based games scored by points; per-play box score, shot clock, and foul-out tracking by league rules.',
    scoring: input.scoring,
    profileFields,
    setupComponent: input.setupComponent,
    liveComponent: input.liveComponent,
    spectatorComponent: input.spectatorComponent,
    nav: {
      owner: [
        { route: '/owner/athletes', label: 'Players', icon: 'users' },
        { route: '/owner/programs', label: 'Programs', icon: 'layers' },
        { route: '/owner/teams', label: 'Teams', icon: 'users' }
      ],
      coach: [
        { route: '/coach/roster', label: 'Players', icon: 'users' },
        { route: '/coach/scoring', label: 'Box scores', icon: 'bar-chart' }
      ],
      athlete: [{ route: '/athlete/scores', label: 'Box scores', icon: 'bar-chart' }]
    }
  };
}
